export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/path2ThankYou.d637f3d7.svg","height":229,"width":329,"blurWidth":0,"blurHeight":0};